import React, { Component } from 'react';
import ApexChart from '../stats/chartDatetime';
import decodeJwt from 'jwt-decode';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
const config = require('./../../config.json');


export default class AmountDatetime extends Component {
    constructor(props) {
        super(props);
        let a;
        if (localStorage.getItem('token')) {
            a = decodeJwt(localStorage.getItem("token")).access_token
        }
        this.state = {
            series: [],
            token: a,
            columnName: this.props.info,
            transactionType: this.props.transactionType,
            xaxis: [{
                x: new Date('2020-11-10').getTime(),
                borderColor: '#999',
                yAxisIndex: 0,
                label: {
                  show: true,
                  text: 'Inicio',
                  style: {
                    color: "#fff",
                    background: '#775DD0'
                  }
                }
            }, {
                x: new Date('2020-10-10').getTime(),
                borderColor: '#999',
                yAxisIndex: 0,
                label: {
                  show: true,
                  text: 'Fase de prueba',
                  style: {
                    color: "#fff",
                    background: '#775DD0'
                  }
                }
            }]
        }
        this.call_for_data = this.call_for_data.bind(this);
    }

    componentDidMount() {
        this.call_for_data();
    }

    async call_for_data() {
        try {
            let a = this.state.token;
            fetch(config.API_URL + "/stats/carga-tiempo?transactionType=" + this.state.transactionType, {
                method: 'GET',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': a
                }
            })
            .then(res => {
                return res.json();
            })
            .then(_data => {
                let newData = [];
                let dh;
                let counterActual = 0;
                let sumaActual = 0;
                let counter = 0;
                let suma = 0;
                let actualMonth = new Date();
                actualMonth = actualMonth.getMonth() ;
                _data.forEach((row) => {
                    dh = moment(row["createdAt"], 'DD/MM/YYYY HH:mm').format("MM/DD/YYYY HH:mm");
                    dh = new Date(dh);
                    newData.push([dh.getTime(), row[this.state.columnName]]);
                    suma += row["amount"];
                    counter += row["counter"];
                    if (dh.getMonth() === actualMonth) {
                        sumaActual += row["amount"];
                        counterActual += row["counter"];
                    }
                    
                })
                this.setState({
                    series: [{
                        data: newData
                    }]
                })
                try {
                    document.getElementById("days-" + this.state.transactionType + "-amount").childNodes[0].textContent = suma;
                    document.getElementById("month-" + this.state.transactionType + "-amount").childNodes[0].textContent = sumaActual;
                    try {
                        document.getElementById("days-" + this.state.transactionType + "-counter").childNodes[0].textContent = counter;
                    } catch {}
                    try {
                        document.getElementById("month-" + this.state.transactionType + "-counter").childNodes[0].textContent = counterActual;
                    } catch {}
                } catch (e) {
                }
            })
            .catch(err => {
                console.log(err);
            })
        } catch (e) {
            console.log(e);
        }
    }

    render() {
        if (this.state.series.length === 0) {
            return (
                <div style={{position: "relative"}}>
                    <CircularProgress style={{marginLeft: '50%'}}/>
                </div>
            )
        }
        return (
            <ApexChart series={this.state.series} xaxis={this.state.xaxis} chartId={this.props.chartId} groupId={this.props.groupId} height={this.props.height} />
        );
    }
}